import styles from './index.css';

import * as React from 'react';
import classNames from 'classnames';

type BlockProps = {
	children?: React.ReactNode;
	half?: boolean;
	title?: string;
}
const Block: React.FunctionComponent<BlockProps> =
	({children, half, title}) => (
		<div className={classNames(styles.block, half && styles.isHalf)}>
			{
				Boolean(title) &&
					<div className={styles.title}>{title}</div>
			}
			{children}
		</div>
	);

export default Block;
